/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionTemplate
 */
export interface OutputUavMissionTemplate {
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionTemplate
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionTemplate
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionTemplate
     */
    createdByName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionTemplate
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionTemplate
     */
    name?: string;
    /**
     * Payload — знімок форми заявки (без дати й часу вильоту). Структура задається фронтом,
     * бекенд її не інтерпретує.
     * @type {{ [key: string]: object; }}
     * @memberof OutputUavMissionTemplate
     */
    payload?: { [key: string]: object; };
}

/**
 * Check if a given object implements the OutputUavMissionTemplate interface.
 */
export function instanceOfOutputUavMissionTemplate(value: object): boolean {
    return true;
}

export function OutputUavMissionTemplateFromJSON(json: any): OutputUavMissionTemplate {
    return OutputUavMissionTemplateFromJSONTyped(json, false);
}

export function OutputUavMissionTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdByName': json['createdByName'] == null ? undefined : json['createdByName'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'payload': json['payload'] == null ? undefined : json['payload'],
    };
}

export function OutputUavMissionTemplateToJSON(value?: OutputUavMissionTemplate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'createdBy': value['createdBy'],
        'createdByName': value['createdByName'],
        'id': value['id'],
        'name': value['name'],
        'payload': value['payload'],
    };
}

